<template>
  <div>
    <div class="fixed-top">
      <LoginNavbar />
    </div>
    <div class="container titleMargin">
      <p>&zwnj;</p>
      <form>
        <div class="row">
          <div class="col-lg-7 mb-2">
            <h2 class="title_fontStyle">Registration & Sign Up</h2>

            <p>&zwnj;</p>

            <div class="form-group mb-4">
              <label for="signupEmail" class="form_title">Email <span class="redpoint">*</span></label>
              <input
                type="email"
                name="email"
                class="form-control form-control-lg"
                aria-describedby="emailHelp"
                placeholder="Please enter a valid email in order to receive a verifcation code"
                id="signupEmail"
                maxlength="50"
                v-model="email"
                :class="{ 'is-invalid': errors.first('email') }"
                v-validate="'required|email'"
                ref="signupEmail"
              />

              <span class="text-danger" style="font-size: 10px" v-if="errors.first('email')"
                ><i class="fas fa-exclamation-triangle"></i> {{ errors.first('email') }}
              </span>
            </div>

            <div class="form-group mb-4">
              <label for="signupPassword" class="form_title "
                >Enter Verification Code <span class="redpoint">*</span></label
              >
              <div class="PcDevice">
                <div class="row align-items-center">
                  <div class="col-8">
                    <input
                      class="form-control form-control-lg"
                      id="signupPassword"
                      type="text"
                      placeholder="6 digit code"
                      maxlength="6"
                      v-model="verificationcode"
                      name="text"
                      :class="{ 'is-invalid': errors.first('text') }"
                      v-validate="'required'"
                      ref="signupPassword"
                    />
                  </div>

                  <div class="col-4">
                    <div class="btn btn-primary px-4 py-2" @click.prevent="getverification">
                      Get Code
                    </div>
                  </div>
                </div>
              </div>

              <div class="MbDevice">
                <div class="row align-items-center">
                  <div class="col-6">
                    <input
                      class="form-control form-control-lg"
                      id="signupPassword"
                      type="text"
                      placeholder="6 digit code"
                      maxlength="6"
                      v-model="verificationcode"
                      name="text"
                      :class="{ 'is-invalid': errors.first('text') }"
                      v-validate="'required'"
                      ref="signupPassword"
                    />
                  </div>

                  <div class="col-6">
                    <div class="btn btn-primary px-4 py-2" @click.prevent="getverification">
                      Get Code
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />

        <div class="row mt-4 ">
          <div class="col-lg-6  px-4">
            <div class="form-group mb-4">
              <label for="signupPassword1" class="form_title ">Password <span class="redpoint">*</span></label>
              <div class="input-group mb-3">
                <input
                  type="password"
                  :type="typePwd"
                  name="password"
                  class="form-control form-control-lg"
                  placeholder=" 8-15 characters"
                  id="signupPassword1"
                  maxlength="20"
                  v-model="password"
                  :class="{ 'is-invalid': errors.first('password') }"
                  v-validate="'required'"
                  ref="password"
                  data-vv-as="Password"
                  autocomplete="new-password"
                />
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon2" @click.prevent="showPw">
                    <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                    <i class="fas fa-eye-slash" v-else-if="typePwd == 'text'"></i>
                  </span>
                </div>
              </div>
              <span class="text-danger" style="font-size: 10px" v-if="errors.first('password')">
                <i class="fas fa-exclamation-triangle"></i> {{ errors.first('password') }}
              </span>
            </div>
          </div>

          <div class="col-lg-6  px-4">
            <div class="form-group mb-4">
              <label for="signupPassword2" class="form_title ">Confirm Password <span class="redpoint">*</span></label>
              <div class="input-group mb-3">
                <input
                  class="form-control form-control-lg"
                  type="password"
                  :type="typePwd"
                  placeholder="Please enter your password again"
                  id="signupPassword2"
                  maxlength="20"
                  autocomplete="new-password"
                  v-model="confirmpassword"
                  name="password_confirmation"
                  :class="{
                    'is-invalid': errors.first('password_confirmation'),
                  }"
                  v-validate="'required|confirmed:password'"
                  data-vv-as="Confirm Password"
                  ref="signupPassword2"
                />

                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon2" @click.prevent="showPw">
                    <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                    <i class="fas fa-eye-slash" v-else-if="typePwd == 'text'"></i>
                  </span>
                </div>
              </div>

              <span class="text-danger" style="font-size: 10px" v-if="errors.first('password_confirmation')">
                <i class="fas fa-exclamation-triangle"></i> {{ errors.first('password_confirmation') }}
              </span>
            </div>
          </div>
        </div>
      </form>

      <div class="row mt-2">
        <div class="col-lg-6 px-4">
          <div class="form-group mb-4">
            <label for="signupName" class="form_title ">Name <span class="redpoint">*</span></label>

            <input
              class="form-control form-control-lg"
              type="text"
              id="signupName"
              maxlength="30"
              v-model="name"
              name="name"
              :class="{ 'is-invalid': errors.first('name') }"
              v-validate="'required'"
              ref="signupName"
            />
            <span class="text-danger" style="font-size: 10px" v-if="errors.first('name')"
              ><i class="fas fa-exclamation-triangle"></i> The Name field is required
            </span>
          </div>
        </div>

        <div class="col-lg-6  px-4">
          <div class="form-group  mb-4">
            <label class="form_title ">Nationality <span class="redpoint">*</span></label>
            <select
              class="form-control form-control-lg text-dark "
              v-model="optionNational"
              name="Nationality"
              :class="{ 'is-invalid': errors.first('Nationality') }"
              v-validate="'required'"
            >
              <option value="">-- Select --</option>
              <option value="TW">Taiwan</option>
              <option value="CN">China</option>
              <option value="HK">Hong Kong</option>
              <option value="MY">Malaysia</option>
              <option value="JP">Japan</option>
              <option value="US">United States</option>
              <option value="SG">Singapore</option>
              <option value="KR">South Korea</option>
              <option value="ID">Indonesia</option>
              <option value="TH">Thailand</option>
              <option value="VN">Vietnam</option>

              <option value="xx" disabled> ------------------------------------</option>
              <option v-for="item in NationalCategory" :value="item.Country_Code">{{ item.eNationality }} </option>
            </select>
            <span class="text-danger" style="font-size: 10px" v-if="errors.first('Nationality')"
              ><i class="fas fa-exclamation-triangle"></i> The Nationality field is required
            </span>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-lg-6 px-4">
          <div class="form-group mb-4">
            <p class="form_title mb-2">Gender <span class="redpoint">*</span></p>

            <div class="custom-control custom-radio custom-control-inline ">
              <input
                class="custom-control-input "
                type="radio"
                name="inlineRadioOptions"
                id="Gender1"
                value="1"
                v-model="gender"
              />
              <label class="custom-control-label" for="Gender1">Male</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline ">
              <input
                class="custom-control-input"
                type="radio"
                name="inlineRadioOptions"
                id="Gender2"
                value="0"
                v-model="gender"
              />
              <label class="custom-control-label" for="Gender2">Female</label>
            </div>
          </div>
        </div>

        <div class="col-lg-6 px-4">
          <div class="form-group mb-4">
            <p class="form_title mb-2">Birthday <span class="redpoint">*</span></p>
            <div class="d-flex align-items-center">
              <div class=" form-inline mr-3">
                <div class="form-group">
                  <select
                    class="form-control text-dark"
                    v-model="optionYear"
                    name="age"
                    :class="{ 'is-invalid': errors.first('age') }"
                    v-validate="'required'"
                  >
                    <option value="">-</option>
                    <option v-for="item in yearList" :value="item">{{ item }} </option>
                  </select>
                </div>
              </div>

              <div>
                /
              </div>

              <div class="form-inline mr-3">
                <div class="form-group ">
                  <select
                    class="form-control text-dark ml-2"
                    v-model="optionMonth"
                    name="age"
                    :class="{ 'is-invalid': errors.first('age') }"
                    v-validate="'required'"
                  >
                    <option value="">-</option>
                    <option v-for="item in monthList" :value="item">{{ item }} </option>
                  </select>
                </div>
              </div>

              <div>
                /
              </div>

              <div class="form-inline mr-3">
                <div class="form-group">
                  <!-- <label for="exampleFormControlSelect1">/</label> -->

                  <select
                    class="form-control text-dark ml-2"
                    v-model="optionDay"
                    name="age"
                    :class="{ 'is-invalid': errors.first('age') }"
                    v-validate="'required'"
                  >
                    <option value="">-</option>
                    <option v-for="item in dayList" :value="item">{{ item }} </option>
                  </select>
                </div>
              </div>
            </div>
            <span class="text-danger" style="font-size: 10px" v-if="errors.first('age')"
              ><i class="fas fa-exclamation-triangle"></i> The Birthday field is required
            </span>
          </div>
        </div>
      </div>

      <div class="row  mt-2">
        <div class="col-lg-6 px-4">
          <div class="form-group mb-4">
            <label class="form_title ">Mobile <span class="redpoint">*</span></label>

            <vue-tel-input
              class="form-control form-control-lg"
              type="tel"
              maxLen="20"
              v-bind="bindProps"
              v-model="allPhone"
              name="interphone"
              :class="{ 'is-invalid': errors.first('interphone') }"
              v-validate="'required'"
            ></vue-tel-input>
            <span class="text-danger" style="font-size: 10px" v-if="errors.first('interphone')"
              ><i class="fas fa-exclamation-triangle"></i> The Mobile field is required
            </span>
          </div>
        </div>

        <div class="col-lg-6  px-4">
          <div class="form-group mb-4 ">
            <label class="form_title ">Occupation <span class="redpoint">*</span></label>
            <select
              class="form-control form-control-lg text-dark "
              v-model="optionOccupation"
              name="Occupation"
              :class="{ 'is-invalid': errors.first('Occupation') }"
              v-validate="'required'"
            >
              <option value="">-- Select --</option>
              <option v-for="item in OccupationsCategory" :value="item.OccupationID"
                >{{ item.eOccupationName }}
              </option>
            </select>
            <span class="text-danger" style="font-size: 10px" v-if="errors.first('Occupation')"
              ><i class="fas fa-exclamation-triangle"></i> The Occupation field is required
            </span>

            <div v-if="occupationOtr" class="mt-2">
              <input
                class="form-control form-control-lg"
                type="text"
                placeholder="Please enter your occupation"
                v-model="occupationOtherContent"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row  mt-2">
        <div class="col-lg-6 px-4">
          <div class="form-group mb-4">
            <label for="signupcompany" class="form_title "> Company <span class="redpoint">*</span></label>

            <input
              class="form-control form-control-lg"
              type="text"
              placeholder="Please enter your company name"
              id="signupcompany"
              maxlength="30"
              v-model="Company"
              name="Company"
              :class="{ 'is-invalid': errors.first('Company') }"
              v-validate="'required'"
              ref="signupcompany"
            />
            <span class="text-danger" style="font-size: 10px" v-if="errors.first('Company')"
              ><i class="fas fa-exclamation-triangle"></i> The Company field is required
            </span>
          </div>
        </div>

        <div class="col-lg-6  px-4">
          <div class="form-group mb-4">
            <label for="inputDepartment" class="form_title ">Department</label>

            <input
              class="form-control form-control-lg"
              type="text"
              id="inputDepartment"
              maxlength="30"
              v-model="Department"
            />
          </div>
        </div>
      </div>

      <div class="row  mt-2">
        <div class="col-lg-6 px-4">
          <div class="form-group mb-4">
            <label class="form_title ">Title <span class="redpoint">*</span></label>
            <select
              class="form-control form-control-lg text-dark"
              v-model="optionTitle"
              name="title"
              :class="{ 'is-invalid': errors.first('title') }"
              v-validate="'required'"
            >
              <option value="">-- Select --</option>
              <option v-for="item in TitleCategory" :value="item.eJobPosition">{{ item.eJobPosition }} </option>
            </select>
            <span class="text-danger" style="font-size: 10px" v-if="errors.first('title')"
              ><i class="fas fa-exclamation-triangle"></i> The Title field is required
            </span>

            <div v-if="titleOtr" class="mt-2">
              <input
                class="form-control form-control-lg"
                type="text"
                placeholder="Please enter your title"
                v-model="titleOtherContnet"
              />
            </div>
          </div>
        </div>

        <div class="col-lg-6  px-4">
          <div class="form-group mb-4">
            <label class="form_title ">Company Tel</label>

            <div class="row">
              <div class="col-8">
                <input
                  class="form-control form-control-lg"
                  type="text"
                  placeholder="eg. 886-2-26596000"
                  maxlength="30"
                  v-model="CompanyTel"
                />
              </div>

              <div class="col-4">
                <input
                  class="form-control form-control-lg"
                  type="text"
                  placeholder="ext."
                  maxlength="10"
                  v-model="CompanyExt"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row  mt-2">
        <div class="col-lg-6 px-4">
          <div class="form-group mb-4">
            <label for="inputDepartment" class="form_title ">Company Address <span class="redpoint">*</span></label>

            <select
              class="form-control form-control-lg text-dark mb-3"
              v-model="optionCompanyCountry"
              name="CompanyAddress"
              :class="{ 'is-invalid': errors.first('CompanyAddress') }"
              v-validate="'required'"
            >
              <option value="">-- Please Choose Country/Region --</option>
              <option value="TW">Taiwan</option>
              <option value="CN">China</option>
              <option value="HK">Hong Kong</option>
              <option value="MY">Malaysia</option>
              <option value="JP">Japan</option>
              <option value="US">United States</option>
              <option value="SG">Singapore</option>
              <option value="KR">South Korea</option>
              <option value="ID">Indonesia</option>
              <option value="TH">Thailand</option>
              <option value="VN">Vietnam</option>

              <option value="xx" disabled> ------------------------------------</option>
              <option v-for="item in CountryCategory" :value="item.Country_Code">{{ item.eCountry }} </option>
            </select>

            <span class="text-danger" style="font-size: 10px" v-if="errors.first('CompanyAddress')"
              ><i class="fas fa-exclamation-triangle"></i> The company country field is required
            </span>

            <div v-if="optionCompanyCountry == 'TW'">
              <select class="form-control form-control-lg text-dark mb-3" v-model="optionPostalCode">
                <option value="">-- Post Code --</option>
                <option v-for="item in PostalCodeCategory" :value="item.PostalCode"
                  >{{ item.PostalCode }} {{ item.ePostalName }}</option
                >
              </select>
            </div>

            <input
              class="form-control form-control-lg"
              type="text"
              id="inputDepartment"
              maxlength="200"
              v-model="CompanyAddress"
              name="address"
              :class="{ 'is-invalid': errors.first('address') }"
              v-validate="'required'"
              placeholder="Please enter company address"
            />

            <span class="text-danger" style="font-size: 10px" v-if="errors.first('address')"
              ><i class="fas fa-exclamation-triangle"></i> The Address field is required
            </span>
          </div>
        </div>
      </div>

      <div class="custom-control custom-checkbox ml-1 mb-5 mt-3 ">
        <input
          class="custom-control-input"
          type="checkbox"
          value=""
          id="signupCheck"
          v-model="checkedrule"
          maxlength="20"
        />
        <label class="form_title custom-control-label" for="signupCheck" style="font-size: 17px">
          <span>I have read, understood and agreed to accept the contents of</span>
          <a href="https://www.chanchao.com.tw/en/otherMember.asp" target="_blank"> Conditions of Membership</a>
          <span v-if="checkText" class="text-danger ml-1">**Please click**</span>
        </label>
      </div>

      <hr />

      <div class=" mx-2 mt-4">
        <h3 class="my-4 title_fontStyle">
          A. What's the main industry of your company ? <span class="redpoint">*</span>
        </h3>

        <div class="row">
          <div class="col-lg-6" v-for="item in IndustriesList">
            <div class="custom-control custom-checkbox my-3">
              <input
                class="custom-control-input"
                type="checkbox"
                :value="item.serno"
                :id="item.eIndustry"
                v-model="optionIndus"
                name="industry"
                :class="{ 'is-invalid': errors.first('industry') }"
                v-validate="'required'"
              />
              <label class="custom-control-label" :for="item.eIndustry">
                {{ item.eIndustry }}
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8">
            <div v-if="indusOtr">
              <input
                type="text"
                class="form-control"
                placeholder="Please enter the industry name"
                v-model="indusOtherContent"
              />
            </div>
          </div>
        </div>

        <span class="text-danger" style="font-size: 15px" v-if="errors.first('industry')"
          ><i class="fas fa-exclamation-triangle"></i> This question field is required
        </span>
      </div>

      <hr />

      <h3 class="my-4 title_fontStyle">B. Purpose of Visit <span class="redpoint">* </span></h3>

      <div class="row">
        <div class="col-lg-6 " v-for="item in VisitPurposeList">
          <div class="custom-control custom-checkbox my-3">
            <input
              class="custom-control-input"
              type="checkbox"
              :value="item.serno"
              :id="item.PurposeID"
              v-model="optionPurpose"
              name="Purpose"
              :class="{ 'is-invalid': errors.first('Purpose') }"
              v-validate="'required'"
            />
            <label class="custom-control-label" :for="item.PurposeID">
              {{ item.eVPurpose }}
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8">
          <div v-if="purposeOtr">
            <input
              type="text"
              class="form-control"
              v-model="purposeOtherContent"
              placeholder="Please enter the purpose of visit"
            />
          </div>
        </div>
      </div>
      <span class="text-danger" style="font-size: 15px" v-if="errors.first('Purpose')"
        ><i class="fas fa-exclamation-triangle"></i> This question field is required
      </span>

      <hr />

      <h3 class="my-4 title_fontStyle">C. How did you find out about the show ? <span class="redpoint">*</span></h3>

      <div class="row">
        <div class="col-lg-6" v-for="item in VisitorHowList">
          <div class="custom-control custom-checkbox my-3">
            <input
              class="custom-control-input"
              type="checkbox"
              :value="item.serno"
              :id="item.eHow"
              v-model="optionHow"
              name="eHow"
              :class="{ 'is-invalid': errors.first('eHow') }"
              v-validate="'required'"
            />
            <label class="custom-control-label" :for="item.eHow">
              {{ item.eHow }}
            </label>
          </div>
        </div>
      </div>
      <span class="text-danger" style="font-size: 15px" v-if="errors.first('eHow')">
        <i class="fas fa-exclamation-triangle"></i> This question field is required
      </span>

      <hr />

      <h3 class="my-4 title_fontStyle">
        D. I would like to receive the following exhibition information <span class="redpoint">*</span>
      </h3>

      <div class="row mb-4">
        <div class="col-12">
          <form>
            <p class="mt-4 mb-2 font-weight-bold">Chan Chao member newsletter <span class="redpoint">*</span></p>
            <div class="custom-control custom-radio custom-control-inline">
              <input
                class="custom-control-input"
                type="radio"
                name="inlineRadioOptions"
                id="newsletter1"
                value="1"
                v-model="MemberLetter"
              />
              <label class="custom-control-label" for="newsletter1">Yes</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input
                class="custom-control-input"
                type="radio"
                name="inlineRadioOptions"
                id="newsletter2"
                value="0"
                v-model="MemberLetter"
              />
              <label class="custom-control-label" for="newsletter2">No</label>
            </div>
          </form>

          <form>
            <p class="mt-4 mb-2 font-weight-bold">
              Information related to this exhibition <span class="redpoint">*</span>
            </p>
            <div class="custom-control custom-radio custom-control-inline">
              <input
                class="custom-control-input"
                type="radio"
                name="inlineRadioOptions"
                id="exhletter1"
                value="1"
                v-model="ExhLetter"
              />
              <label class="custom-control-label" for="exhletter1">Yes</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input
                class="custom-control-input"
                type="radio"
                name="inlineRadioOptions"
                id="exhletter2"
                value="0"
                v-model="ExhLetter"
              />
              <label class="custom-control-label" for="exhletter2">No</label>
            </div>
          </form>
        </div>
      </div>

      <hr />

      <div class="btn btn-primary px-5 py-2 mt-4 mb-5" @click.prevent="signupBtn()">SUBMIT</div>
    </div>
  </div>
</template>

<script>
  import LoginNavbar from '@/components/LoginNavbar.vue'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LoginNavbar,
    },

    data() {
      return {
        CSRF_Token: '',
        gender: 1,
        name: '',
        email: '',
        verificationcode: '',
        confirmpassword: '',
        password: '',
        allPhone: '',
        bindProps: {
          mode: 'international',
        },
        checkedrule: false,
        alertTitle: '',
        alertText: '',
        lastUrl: '',
        checkText: false,
        typePwd: 'password',

        Company: '',
        Department: '',
        CompanyTel: '',
        CompanyExt: '',
        CompanyAddress: '',

        NationalCategory: [],
        OccupationsCategory: [],
        CountryCategory: [],
        PostalCodeCategory: [],
        TitleCategory: [],

        optionNational: '', //選擇國籍
        optionOccupation: '', //選擇職業
        optionCompanyCountry: '', //選擇國家
        optionPostalCode: '', //選擇郵遞區號
        optionTitle: '', //選擇職稱

        //Age
        yearList: [],
        monthList: [],
        dayList: [],
        optionYear: '',
        optionMonth: '',
        optionDay: '',

        //問題
        VisitPurposeList: [],
        VisitorHowList: [],
        IndustriesList: [],

        ExhLetter: 1,
        MemberLetter: 1,

        optionIndus: [],
        optionPurpose: [],
        optionHow: [],
        s_optionPurpose: '',
        s_optionIndus: '',
        s_optionHow: '',

        purposeOtr: false,
        indusOtr: false,
        titleOtr: false,
        occupationOtr: false,

        purposeOtherContent: '',
        indusOtherContent: '',
        titleOtherContnet: '',
        occupationOtherContent: '',
      }
    },

    computed: {
      ...mapGetters(['exhcode']),
    },

    methods: {
      reload() {
        window.location.reload()
      },

      showPw() {
        const vm = this
        vm.typePwd = vm.typePwd === 'password' ? 'text' : 'password'
      },

      signupBtn() {
        const vm = this

        // Divide Phone Number

        let countryCode = vm.allPhone.substr(1).substring(0, vm.allPhone.indexOf(' ') - 1)
        let phoneNum = vm.allPhone.substring(vm.allPhone.indexOf(' '), vm.allPhone.length).replace(/\s*/g, '')

        const signupinfo = {
          Email: vm.email,
          VerificationCode: vm.verificationcode,
          spass: vm.password,
          exhcode: vm.exhcode,
          code: '',
          cname: vm.name,
          gender: vm.gender, //男1女0
          Y_DOB: vm.optionYear,
          M_DOB: vm.optionMonth,
          D_DOB: vm.optionDay,
          Nationality: vm.optionNational,
          mobile: phoneNum,
          MobileCountryCode: countryCode,
          company: vm.Company,
          Division: vm.Department,
          title: vm.optionTitle,
          title_oth: vm.titleOtherContnet,
          Tel: vm.CompanyTel,
          Ext: vm.CompanyExt,
          country: vm.optionCompanyCountry,
          PoBox: vm.optionPostalCode,
          address: vm.CompanyAddress,
          Occupation: vm.optionOccupation,
          Occupation_oth: vm.occupationOtherContent,
          MemberEDM: vm.MemberLetter,
          ExpoEDM: vm.ExhLetter,
          Ind: vm.s_optionIndus,
          Ind_oth: vm.indusOtherContent,
          VJob: '',
          VJob_oth: '',
          VPurpose: vm.s_optionPurpose,
          VPurpose_oth: vm.purposeOtherContent,
          VHow: vm.s_optionHow,
          VHow_oth: '',
          VTime: '',
          CSRF: vm.CSRF_Token,

          OnlineExpoStatus: 1,

          Nowdate: '',
          ExpoBegin: '',
          ExpoEnd: '',
          ExpoPreOpen: '',
        }

        const url = 'https://www.chanchao.com.tw/apiRegister/v1/PreReg_regFormFirstTimeScript'

        vm.$validator.validate().then((valid) => {
          if (valid) {
            if (vm.password.length > 7) {
              if (vm.checkedrule) {
                vm.$http.post(url, signupinfo).then(function(response) {
                  if (response.data == '200') {
                    vm.alertTitle = 'Success'
                    vm.alertText = 'Congratulations, your account has been successfully created.'
                    vm.alertSuccessSignup()
                  } else if (response.data == '252') {
                    window.location.replace(`https://www.chanchao.com.tw/en/`)
                  } else if (response.data == '253') {
                    vm.alertText = 'Exhibition does not exists.'

                    vm.alertError()
                  } else if (response.data == '254') {
                    vm.alertText = 'Please log in first to complete the visitor online registration.	'

                    vm.alertError()
                  } else if (response.data == '255') {
                    vm.alertText = 'Email error'

                    vm.alertError()
                  } else if (response.data == '256') {
                    vm.alertText = 'Verification code error, please retrieve a new verification code.'

                    vm.alertError()
                  } else if (response.data == '257') {
                    vm.alertText =
                      'This e-mail has been registered. Please log in to proceed with the visitor registration.'

                    vm.alertError()
                  } else {
                    vm.alertText = 'Error, please check your data and login again.'
                    vm.alertError()
                  }
                })
              } else {
                vm.alertText = 'Please accept conditions of membership and click the checkbox.'
                vm.alertError()
                vm.checkText = true
              }
            } else {
              vm.alertText = 'Please enter a value between 8 and 20 characters long.'
              vm.alertError()
              vm.$refs.password.style.borderColor = 'red'
              vm.$refs.signupPassword2.style.borderColor = 'red'
            }
          } else {
            vm.alertText = 'Your request could not be completed.'
            vm.alertError()
          }
        })
      },

      getverification() {
        const vm = this
        if (vm.lastUrl.length === 0) {
          vm.lastUrl = 'https://www.chanchao.com.tw/en/member'
        }

        const url = 'https://www.chanchao.com.tw/apiRegister/v1/verification/en'

        const verificationemail = {
          Email: vm.email,
          CSRF: vm.CSRF_Token,
          exhcode: vm.exhcode,
        }

        vm.$http.post(url, verificationemail).then(function(response) {
          if (response.data == '200') {
            vm.alertText = vm.email
            vm.alertTitle = 'Verification code has been sent to your email.'

            vm.alertSuccess()
          } else if (response.data == '252') {
            vm.alertText = 'Your email is already registered. Please proceed to the login page.'
            vm.alertError()
            vm.$refs.signupEmail.style.borderColor = 'red'
          } else if (response.data == '253') {
            vm.alertText = 'Please enter email.'
            vm.alertError()
            vm.$refs.signupEmail.style.borderColor = 'red'
          } else {
            vm.alertText = 'Your request could not be completed.'
            vm.alertError()
          }
        })
      },

      alertError() {
        const vm = this
        vm.$swal({
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',

          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },

      alertSuccess() {
        const vm = this
        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'success',
          confirmButtonText: 'OK',

          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },

      alertSuccessSignup() {
        const vm = this

        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'success',
          confirmButtonText: 'OK',

          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        }).then(function() {
          const registerApi = `https://www.chanchao.com.tw/apiOnlineExpo/v1/CheckRegister/${vm.exhcode}`
          vm.$http.post(registerApi).then((response) => {
            if (response.data == 200) {
              if (vm.Nowdate < vm.ExpoBegin) {
                vm.OnlineExpoStatus = 1
              } else if (vm.Nowdate >= vm.ExpoBegin && vm.Nowdate <= vm.ExpoEnd) {
                vm.OnlineExpoStatus = 2
              } else if (vm.Nowdate > vm.ExpoEnd) {
                vm.OnlineExpoStatus = 3
              }

              if (vm.OnlineExpoStatus == 1) {
                vm.$router.push({ path: '/Landing' })
              } else if (vm.OnlineExpoStatus == 2) {
                let ExhUrl = sessionStorage.getItem('Exhurl')

                if (ExhUrl) {
                  window.location.replace(ExhUrl)
                } else {
                  window.location.replace(`https://www.chanchao.com.tw/touchtaiwan/onlineexpo/Home`)
                }
              } else if (vm.OnlineExpoStatus == 3) {
                vm.$router.push({ path: '/Landing' })
              }
            } else if (response.data == 254) {
              if (vm.Nowdate < vm.ExpoPreOpen) {
                vm.OnlineExpoStatus = 1
              } else if (vm.Nowdate >= vm.ExpoPreOpen && vm.Nowdate <= vm.ExpoEnd) {
                vm.OnlineExpoStatus = 2
              } else if (vm.Nowdate > vm.ExpoEnd) {
                vm.OnlineExpoStatus = 3
              }

              if (vm.OnlineExpoStatus == 1) {
                vm.$router.push({ path: '/Landing' })
              } else if (vm.OnlineExpoStatus == 2) {
                let ExhUrl = sessionStorage.getItem('Exhurl')

                if (ExhUrl) {
                  window.location.replace(ExhUrl)
                } else {
                  window.location.replace(`https://www.chanchao.com.tw/touchtaiwan/onlineexpo/Home`)
                }
              } else if (vm.OnlineExpoStatus == 3) {
                vm.$router.push({ path: '/Landing' })
              }
            }
          })
        })
      },
    },

    watch: {
      optionPurpose: function(newValue) {
        this.s_optionPurpose = newValue.toString()

        if (newValue.includes('8')) {
          this.purposeOtr = true
        } else {
          this.purposeOtr = false
        }
      },

      optionIndus: function(newValue) {
        this.s_optionIndus = newValue.toString()

        if (newValue.includes('17')) {
          this.indusOtr = true
        } else {
          this.indusOtr = false
        }
      },

      optionHow: function(newValue) {
        this.s_optionHow = newValue.toString()
      },

      optionTitle: function(newValue) {
        if (newValue.includes('Other')) {
          this.titleOtr = true
        } else {
          this.titleOtr = false
        }
      },

      optionOccupation: function(newValue) {
        if (newValue.includes('13')) {
          this.occupationOtr = true
        } else {
          this.occupationOtr = false
        }
      },

      optionMonth: function(newValue) {
        if (newValue == 2) {
          this.dayList.length = 0
          for (let days = 1; days < 29; days++) {
            this.dayList.push(days)
          }
        } else if (newValue % 2 == 0) {
          this.dayList.length = 0
          for (let days = 1; days < 31; days++) {
            this.dayList.push(days)
          }
        } else {
          this.dayList.length = 0
          for (let days = 1; days < 32; days++) {
            this.dayList.push(days)
          }
        }
      },
    },

    created() {
      const vm = this

      //取得當前時間

      vm.$http
        .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/Exhibitions/DF2242F61B11D1929128800348BA5A45?lang=en`)
        .then((response) => {
          vm.Nowdate = Date.parse(new Date()).valueOf()
          vm.ExpoBegin = response.data.OnlineExpoBegin
          vm.ExpoEnd = response.data.OnlineExpoEnd
          vm.ExpoPreOpen = response.data.OnlineExpoMovein
        })

      //更換英文語系
      vm.$i18n.locale = 'en'

      vm.$http.get('https://www.chanchao.com.tw/apiRegister/v1/Nationalities?Lang=en').then((response) => {
        vm.NationalCategory = response.data
      })

      vm.$http.get('https://www.chanchao.com.tw/apiRegister/v1/Occupations?Lang=en').then((response) => {
        vm.OccupationsCategory = response.data
      })

      vm.$http.get('https://www.chanchao.com.tw/apiRegister/v1/Countries?Lang=en').then((response) => {
        vm.CountryCategory = response.data
      })

      vm.$http.get('https://www.chanchao.com.tw/apiRegister/v1/PostalCodes').then((response) => {
        vm.PostalCodeCategory = response.data
      })

      vm.$http.get('https://www.chanchao.com.tw/apiRegister/v1/Titles?Lang=en').then((response) => {
        vm.TitleCategory = response.data
      })

      //年月日欄位

      let today = new Date()
      let thisyear = today.getFullYear()
      for (let i = thisyear; i > thisyear - 100; i--) {
        vm.yearList.push(i)
      }

      for (let mon = 1; mon < 13; mon++) {
        vm.monthList.push(mon)
      }

      for (let days = 1; days < 32; days++) {
        vm.dayList.push(days)
      }

      //問卷

      vm.$http.get(`https://www.chanchao.com.tw/apiRegister/v1/Industries/${vm.exhcode}?Lang=en`).then((response) => {
        vm.IndustriesList = response.data
      })

      vm.$http.get(`https://www.chanchao.com.tw/apiRegister/v1/VisitPurpose/${vm.exhcode}?Lang=en`).then((response) => {
        vm.VisitPurposeList = response.data
      })

      vm.$http.get(`https://www.chanchao.com.tw/apiRegister/v1/VisitorHow?Lang=en`).then((response) => {
        vm.VisitorHowList = response.data
      })

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        let CSRFToken = response.data
        vm.CSRF_Token = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: CSRFToken,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      })
    },
  }
</script>

<style lang="scss" scoped>
  input {
    line-height: 38px;
    padding-left: 20px;
    font-size: 20px;
  }

  .form-control.is-invalid,
  .was-validated .form-control:invalid {
    background-position: right calc(0.375em + 0.8rem) center;
  }
  // 勾選欄
  .custom-control-label::before {
    position: absolute;
    top: 0.1rem;
    left: -1.5rem;
    display: block;
    width: 1.3rem;
    height: 1.3rem;
    pointer-events: none;
    content: '';
    background-color: #fff;
    border: #adb5bd solid 1px;
  }

  .custom-control-label::after {
    position: absolute;
    top: 0.25rem;
    left: -22px;
    display: block;
    width: 1rem;
    height: 1rem;
    content: '';
    background: 50% / 50% 50% no-repeat;
  }

  .custom-control-label {
    position: relative;
    margin-bottom: 0;
    vertical-align: top;
    padding-left: 12px;
  }

  .titleMargin {
    margin-top: 142px;
  }

  @media (max-width: 576px) {
    .titleMargin {
      margin-top: 80px;
    }
  }
</style>
